'use strict';

function Week13ResidentialCareTypeFactory(Week5ResidentialCareType, constants) {

  function Week13ResidentialCareType(userInputModel) {
    var week5ResidentialCareType = new Week5ResidentialCareType(userInputModel);

    this.getTotalWeeklyExpenses = function () {
      return week5ResidentialCareType.getTotalWeeklyExpenses();
    };

    this.getPartnerMinimumIncomeGuarantee = function (results) {
      return week5ResidentialCareType.getPartnerMinimumIncomeGuarantee(results);
    };

    this.personalLivingAllowance = function (results) {
      return week5ResidentialCareType.personalLivingAllowance(results);
    };

    this.getDisregardedAttendanceAllowance = function () {
      return week5ResidentialCareType.getDisregardedAttendanceAllowance();
    };

    this.getDisregardedPrivatePension = function () {
      return week5ResidentialCareType.getDisregardedPrivatePension();
    };

    this.getDisregardedCarersPremium = function (isEntitledToPremium, carersAllowance) {
      return week5ResidentialCareType.getDisregardedCarersPremium(isEntitledToPremium, carersAllowance);
    };

    this.getChildrensPremium = function () {
      return week5ResidentialCareType.getChildrensPremium();
    };

    this.getDisregardedPensionSavingsCredit = function (userType, results) {
      var respiteValue = week5ResidentialCareType.getDisregardedPensionSavingsCredit(userType, results);
      return Math.min(constants.pensionCreditAllowances.maxDisregardSingle, respiteValue);
    };

    this.getAllowableWorkingTaxCredit = function (workingTaxCreditIncome) {
      return userInputModel.isCouple() ? workingTaxCreditIncome / 2 : workingTaxCreditIncome;
    };

    this.adjustContribution = function (contributionUpperBound, results) {
      var applicantData = userInputModel.getApplicantData();
      var savingsThreshold = constants.residential.totalSavingsThreshold;
      var individualCapital = applicantData.individualCapital + (0.5 * userInputModel.getJointCapital());
      var weeks5To12Amount = week5ResidentialCareType.adjustContribution(contributionUpperBound, results);

      if (applicantData.hasAdditionalProperties) {
        return constants.maxWeeklyContribution;

      } else if (individualCapital < savingsThreshold && applicantData.ownsProperty) {
        return weeks5To12Amount + applicantData.getWeeklyIncome('attendanceAllowance');

      } else {
        return weeks5To12Amount;
      }
    };
  }

  return Week13ResidentialCareType;
}

Week13ResidentialCareTypeFactory.$inject = ['Week5ResidentialCareType', 'kirkleesCareAssessmentConstants'];

angular.module('kerp-forms.forms').factory('Week13ResidentialCareType', Week13ResidentialCareTypeFactory);
